'use client'

import { useNavigate } from 'react-router-dom'
import MeetupForm from '@/features/meetups/meetup-form'
import { useUser } from '@/hooks/use-user'

function CreateMeetupPage() {
  const navigate = useNavigate()
  const { user } = useUser()

  const handleSuccess = (data: any) => {
    navigate(`/meetups/${data.id}`)
  }

  const handleCancel = () => {
    navigate('/meetups')
  }

  if (!user) {
    return (
      <div className="container mx-auto p-6">
        <div className="text-center py-12">Loading user data...</div>
      </div>
    )
  }

  return (
    <div className="container mx-auto p-6">
      <h1 className="text-2xl font-bold mb-6">Create Meetup</h1>
      <MeetupForm 
        userId={user.id}
        onSuccess={handleSuccess} 
        onCancel={handleCancel}
      />
    </div>
  )
}

export default CreateMeetupPage
